export const featureKey = 'genesysCloudNotifications';
